import './mix&twist2/style';
import FormStructure from './mix&twist2/form_structure';

export default FormStructure;